import type { FC, ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SimpleTextProps {
  classes?: string;
  children: ReactNode;
}

const SimpleText: FC<SimpleTextProps> = ({ classes, children }) => {
  return <p className={cn("text-sm text-zinc-500", classes)}>{children}</p>;
};

export default SimpleText;
